import { messages } from "@/shared/i18n";

/**
 * Login feature error code mappings
 *
 * Maps backend RFC 7807 Problem Details error codes to localized messages.
 */
export const LOGIN_ERROR_CODES: Record<string, string> = {
  "User.InvalidCredentials": messages.login.errors.invalidCredentials,
};
